export default __webpack_public_path__ + "static/Conference_01-fa8384a5276bd1f4c8fbc740bdd42cde.jpg";